<script>
import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";
export default {
    name: "BursPostBtn",
    components: {
        DatePicker,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        from: {
            type: String,
            default: "burs",
        },
        journals: {
            type: Array,
            default: () => [],
        },
        buttonName: {
            type: String,
            default: "Post",
        },
    },
    validations: {
        form: {
            postDate: { required },
        },
    },
    data() {
        return {
            form: {
                postDate: new Date(),
                journal: null,
            },
            jev: {
                jevNumber: null,
            }
        };
    },
    methods: {
        submitPost() {
            this.$emit("postNow", this.from === 'jev' ? this.jev :  this.form);
        },
        updateForm(){
            if(this.data.modeOfPayment === 'Cash'){
                let fnd = this.journals.find(x => x.journalTypeName === 'Cash Disbursement Journal');
                this.form.journal = fnd ? fnd.id : null;
            }else if(this.data.modeOfPayment === 'Check'){
                let fnd = this.journals.find(x => x.journalTypeName === 'Check Disbursement Journal');
                this.form.journal = fnd ? fnd.id : null;
            }else if(this.data.modeOfPayment === 'ADA'){
                let fnd = this.journals.find(x => x.journalTypeName.includes('Authority'));
                this.form.journal = fnd ? fnd.id : null;
            }else{
                this.form.journal = null;
            }
        },
        async generateJevNumber(){
            await this.$store.dispatch('jev/generateJevNumber', {
                cycle: this.$store.state.data.cycle,
                campusId: this.$store.state.data.selectedCampus.id, 
            })
            .then(res => {
                if (res.data.error) {
                    return this.showToast(res.data.errorMessage, 'error');
                }
                this.jev.jevNumber = res.data;
            })
            .catch(err => {
                this.showToast('Something went wrong while fetching Subsidiary Ledger!', 'error');
            });
        },
        postForm() {
            this.data.showPopover = true;
            if(this.from === 'jev'){
                this.generateJevNumber();
            }
            this.updateForm();
        },
    },
}
</script>
<template>
    <button type="buttton" class="btn btn-outline-success btn-rounded" :id="`${from}-post-${data.id}`" @click="postForm">
        <i class="bx bx-check"></i> {{buttonName}}
        <b-popover
            :target="`${from}-post-${data.id}`"
            triggers="click"
            placement="left"
            custom-class="popover-report"
            :show.sync="data.showPopover"
        >
            <template v-slot:title>
                <div class="d-flex align-items-center justify-content-between">
                <small>Post Details</small>
                <span
                    class="bx bx-x font-size-14 cursor-pointer"
                    @click="data.showPopover = false"
                ></span>
                </div>
            </template>
            <form @submit.prevent="submitPost">
                <div class="mb-3 px-3 pt-3" v-if="from !== 'jev'">
                    <label for="postDate" class="mb-0">Date Time {{buttonName}}</label>
                    <date-picker
                        id="postDate"
                        v-model="form.postDate"
                        :first-day-of-week="1"
                        lang="en"
                        type="datetime"
                        placeholder="Enter Post Date..."
                        format="MMM D YYYY hh:mm A"
                        :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30', format: 'hh:mm A'}"
                        :class="{ 'is-invalid': $v.form.postDate.$error }"
                    >
                    </date-picker>
                    <div v-if="$v.form.postDate.$error" class="invalid-feedback">
                        <span v-if="!$v.form.postDate.required">{{buttonName}} Date is required.</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-sm btn-success">{{buttonName}} Now!</button>
                    <button type="button" class="btn btn-sm btn-text" @click="data.showPopover = false;">Cancel</button>
                </div>
            </form>
        </b-popover>
    </button>
</template>